import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import MobileDrawer from './MobileDrawer';

const Layout = ({ children }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50 dark:bg-gray-900">
      {/* Desktop Sidebar - hidden on mobile and tablet */}
      <div className="hidden lg:block flex-shrink-0">
        <Sidebar variant="desktop" />
      </div>

      {/* Tablet Sidebar - visible on tablet, hidden on mobile and desktop */}
      <div className="hidden md:block lg:hidden flex-shrink-0">
        <Sidebar variant="tablet" />
      </div>

      {/* Mobile Drawer */}
      <MobileDrawer isOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />

      {/* Main Content Area - takes remaining space, handles internal scrolling if needed */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header - fixed at top */}
        <Header onMenuClick={() => setMobileMenuOpen(true)} />

        {/* Page Content - scrollable only if content exceeds, but prevent by compact design */}
        <main className="flex-1 overflow-y-auto p-4 md:p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;